import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
// rsuite
import Table from 'rsuite/Table'
import Tag from 'rsuite/Tag'
import Toggle from 'rsuite/Toggle'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'
// icons

// includes
import Edit2 from '@rsuite/icons/Edit'
import RemindOutlineIcon from '@rsuite/icons/RemindOutline'
import TrashIcon from '@rsuite/icons/Trash'
import {isEmpty} from 'lodash'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import Modal from 'rsuite/Modal'
import Pagination from 'rsuite/Pagination'
import IconButton from 'rsuite/esm/IconButton'
import * as menuRedux from 'src/app/modules/cms'
import {ItemType, StateParamsModel} from 'src/app/modules/common/Model'
import checkCollegeSetting from 'src/app/modules/common/checkCollegeSetting'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'
import {MenuModal} from '../Model/MenuModal'
import {IMenuState} from '../redux/reducer'
import AddMenuModal from './AddMenuModal'
import AddMenuModals from './AddMenuModals'
const MenuManager = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<MenuModal>()
  const handleClose = () => setOpen(false)
  const {
    data,
    loading,
    singleEnableSuccess,
    singleDisableSuccess,
    enableSuccess,
    disableSuccess,
    toggleLoading,
    success,
    sortSuccess,
    deleteSuccess,
    sortMenuData,
    menuList,
  } = useSelector((state: IMenuState | any) => state.menuManager)
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const [alertOpen, setAlertOpen] = useState(false)
  const [toggleAlertOpen, setToggleAlertOpen] = useState(false)
  const [toggleData, setToggleData] = useState()
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const [openSortModal, setOpenSortModal] = useState(false)

  useEffect(() => {
    dispatch(menuRedux.menu.actions.getMenu(params))
  }, [params])

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const enableMenuData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(menuRedux.menu.actions.enableMenu(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const disableMenuData = () => {
    if (!isEmpty(checkedValues)) {
      const formData = checkedValues.map((d: string) => ({
        id: d,
      }))
      dispatch(menuRedux.menu.actions.disableMenu(formData))
    } else {
      toast.error('No data Selected')
    }
  }

  const Cell = Table.Cell

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    function handleAction() {
      alert(`id:${rowData[dataKey]}`)
    }
    return (
      <Cell {...props} className='link-group'>
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              data-cy='edit-button'
              icon={<Edit2 />}
            />
          </Whisper>
        </CheckPermissions>

        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let menuId = [rowData.id]
                setCheckedValues(menuId)
              }}
              data-cy='delete-button'
              icon={<TrashIcon />}
            />
          </Whisper>
        </CheckPermissions>

        <Whisper placement='top' trigger='hover' speaker={<Tooltip>Status</Tooltip>}>
          <Toggle
            size='sm'
            disabled={toggleLoading}
            checked={rowData.statusData?.systemName === 'active' ? true : false}
            onClick={() => {
              if (rowData?.parentId === null) {
                setToggleAlertOpen(true)
                setToggleData(rowData)
              } else {
                handleToggleAction(rowData)
              }
            }}
            data-cy='toggle-button'
          />
        </Whisper>
      </Cell>
    )
  }

  const handleToggleAction = (data: any) => {
    data?.statusData?.systemName === 'active'
      ? dispatch(menuRedux.menu.actions.singleDisableMenu({id: data.id}))
      : dispatch(menuRedux.menu.actions.singleEnableMenu({id: data.id}))
  }

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Menu Name',
      dataKey: 'name',
      flexGrow: 1,
      cell: <Cell dataKey='name' />,
      sortable: true,
    },
    {
      label: 'Menu Type',
      dataKey: 'menuData',
      flexGrow: 1,
      cell: <Cell>{(rowData) => (rowData.menuData ? rowData.menuData.displayName : '-')}</Cell>,
      sortable: false,
    },
    {
      label: 'Slug',
      dataKey: 'slug',
      flexGrow: 1,
      cell: <Cell dataKey='slug' />,
      sortable: true,
    },
    {
      label: 'Status',
      dataKey: 'status',
      width: 85,
      cell: (
        <Cell>
          {(rowData) =>
            rowData?.statusData?.systemName === 'active' ? (
              <Tag color='green' size='sm'>
                Active
              </Tag>
            ) : (
              <Tag color='red' size='sm'>
                Inactive
              </Tag>
            )
          }
        </Cell>
      ),
      sortable: false,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const menuData = data?.menu
    ? data?.menu?.map((item: any, i: number) => ({
        sn: (params?.page - 1) * params?.limit + (i + 1),
        contentData: item.content,
        contentId: item?.content?.id,
        allowInRoute: item?.allowInRoute,
        featuredImage: item.featuredImage,
        featuredImageText: item.featuredImageText,
        featuredImageTextNp: item.featuredImageTextNp,
        featuredImageUrl: item.featuredImageUrl,
        file: item.file,
        firstButtonLink: item.firstButtonLink,
        firstButtonText: item.firstButtonText,
        firstButtonTextNp: item.firstButtonTextNp,
        headerImage: item.headerImage,
        headerShortDescription: item.headerShortDescription,
        headerShortDescriptionNp: item.headerShortDescriptionNp,
        hideInWebsite: item.hideInWebsite.id,
        iconType: item.iconType.id,
        id: item.id,
        menuIcon: item.menuIcon,
        menuImage: item.menuImage,
        menuLinkType: item.menuLinkType.id,
        topMenu: item.topMenu,
        topMenuId: item.topMenu?.id,
        menuData: item.menuType,
        menuType: item.menuType.id,
        metaKeyword: item.metaKeyword,
        metaTitle: item.metaTitle,
        metaTitleNP: item.metaTitleNP,
        metaDescription: item.metaDescription,
        metaDescriptionNP: item.metaDescriptionNP,
        // name: item.name,
        nameNp: item.nameNp,
        orderId: item.orderId,
        parentId: item?.parentId,
        productId: item.product?.id,
        secondButtonLink: item.secondButtonLink,
        secondButtonText: item.secondButtonText,
        secondButtonTextNp: item.secondButtonTextNp,
        serviceId: item.service?.id,
        showNotificationBell: item.showNotificationBell,
        showToLoggedInUserOnly: item.showToLoggedInUserOnly,
        slug: item.slug,
        status: item.status.id,
        statusData: item.status,
        name: item.name,
        programId: item?.program?.id,
        url: item.url,
        structure_data: item.structure_data,
        description: item?.description,
        descriptionNp: item?.descriptionNp,
        shortDescription: item?.shortDescription,
        shortDescriptionNp: item?.shortDescriptionNp,
      }))
    : []

  useEffect(() => {
    if (deleteSuccess) {
      toast.success('Menu deleted successfully')
    }
    if (enableSuccess) {
      toast.success('Menu enabled successfully')
    }
    if (disableSuccess) {
      toast.success('Menu disabled successfully')
    }
    handleChecked([])
    dispatch(menuRedux.menu.actions.getMenu(params))
  }, [deleteSuccess, success, enableSuccess, disableSuccess])

  useEffect(() => {
    if (singleEnableSuccess) {
      toast.success('Menu enabled successfully')
    }
    if (singleDisableSuccess) {
      toast.success('Menu disabled successfully')
    }
    handleChecked([])
  }, [singleDisableSuccess, singleEnableSuccess])

  const handleChecked = (values: Array<string>) => {
    setCheckedValues(values)
  }

  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const handleDelete = () => {
    let menuId = checkedValues?.map((value) => ({id: value}))
    dispatch(menuRedux.menu.actions.deleteMenu(menuId))
    handleAlertClose()
  }

  const handleRefresh = () => {
    dispatch(menuRedux.menu.actions.getMenu())
  }

  const handleGetAllData = () => {
    dispatch(menuRedux.menu.actions.getAllMenu())
  }

  const handleSubmitSort = (data: Array<ItemType>) => {
    let body = {
      menuLists: data?.map((item) => ({
        menuId: item?.keyId,
        parentId: item?.parentId,
      })),
    }
    for (let menu in data) {
      const childrens = data[menu].children
      if (childrens?.length > 0) {
        const updatedChildrens = childrens.map((child: {id: string; parentId: string}) => {
          return {menuId: child.id, parentId: child.parentId}
        })
        body.menuLists.push(...updatedChildrens)
      }
      for (let gMenu in data[menu].children) {
        const gchild = data[menu].children[gMenu].children
        if (gchild?.length > 0) {
          const updatedChildrens = gchild.map((child: {id: string; parentId: string}) => {
            return {menuId: child.id, parentId: child.parentId}
          })
          body.menuLists.push(...updatedChildrens)
        }

        for (let innerMenu in data[menu].children[gMenu].children) {
          const innerChild = data[menu].children[gMenu].children[innerMenu].children
          if (innerChild?.length > 0) {
            const updatedChildrens = innerChild.map((child: {id: string; parentId: string}) => {
              return {menuId: child.id, parentId: child.parentId}
            })
            body.menuLists.push(...updatedChildrens)
          }
        }
      }
    }

    dispatch(menuRedux.menu.actions.sortMenu(body))
  }

  useEffect(() => {
    if (!isEmpty(sortMenuData) && sortSuccess) {
      toast.success('Menu sorted successfully')
      dispatch(menuRedux.menu.actions.sortMenuReset())
      setParams({...params, limit: 10})
      dispatch(menuRedux.menu.actions.getMenu(params))
      setOpenSortModal(false)
    }
  }, [sortMenuData, sortSuccess])

  const isCollegeSettings = checkCollegeSetting()
  return (
    <>
      <div className='shadow p-3 bg-white rounded'>
        <DesignComponent
          moduleName='Menu Manager'
          params={params}
          setParams={setParams}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          handleRefresh={handleRefresh}
          exportShow={false}
          importShow={false}
          enableMultiple={enableMenuData}
          disableMultiple={disableMenuData}
          data={menuData}
          sortShow={true}
          sortButtonName='Menu Management'
          handleSubmitSort={handleSubmitSort}
          handleGetAllData={handleGetAllData}
          openSortModal={openSortModal}
          setOpenSortModal={setOpenSortModal}
          loading={loading}
        />
        <div className='datatable'>
          <RSuiteTable
            showCheckbox={true}
            columns={columns}
            checkedValues={checkedValues}
            onChecked={handleChecked}
            data={menuData}
            handleSort={handleSort}
            showLoading={loading}
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            maxButtons={5}
            className='mt-5'
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
          />
          {open && isCollegeSettings ? (
            <AddMenuModals
              open={open}
              params={params}
              setParams={setParams}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          ) : (
            <AddMenuModal
              open={open}
              params={params}
              setParams={setParams}
              handleClose={handleClose}
              actionType={actionType}
              editSelectedData={editSelectedData}
            />
          )}
        </div>
        <>
          {alertOpen &&
            (!isEmpty(checkedValues) ? (
              <DeleteModal
                handleClick={() => handleDelete()}
                isOpen={alertOpen}
                handleClose={() => handleAlertClose()}
              />
            ) : (
              toast.error('No data selected') && setAlertOpen(false)
            ))}
        </>

        {toggleAlertOpen && (
          <div className='modal-container'>
            <Modal
              backdrop='static'
              role='alertdialog'
              open={toggleAlertOpen}
              onClose={() => setToggleAlertOpen(false)}
              enforceFocus={false}
              size='xs'
            >
              <Modal.Body className='text-center'>
                <RemindOutlineIcon className='mb-3 text-danger' style={{fontSize: '60px'}} />
                <h2 className='d-flex justify-content-center'>Do you want to proceed ?</h2>
              </Modal.Body>
              <Modal.Footer className='text-center'>
                <button
                  onClick={() => {
                    handleToggleAction(toggleData)
                    setToggleAlertOpen(false)
                  }}
                  data-cy='yes-button'
                  className='btn btn-primary btn-sm ms-3 w-25'
                >
                  Yes
                </button>
                <button
                  onClick={() => setToggleAlertOpen(false)}
                  className='btn btn-secondary btn-sm ms-3 w-25'
                  data-cy='no-button'
                >
                  No
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    </>
  )
}

export default MenuManager
